module.exports = __webpack_public_path__ + "img/1.05b6cb9a.png";